export default __webpack_public_path__ + "static/media/shopping.4802784a.png";